<template>
  <v-card class="elevation-12" :loading="loading">
    <v-toolbar color="success" dark flat>
      Ввод вручения
    </v-toolbar>

    <v-card-title>

    </v-card-title>
    <v-card-text>
      <v-menu v-model="performDateMenu" transition="scale-transition" offset-y :nudge-right="40" max-width="290px" min-width="290px">
        <template v-slot:activator="{ on }">
          <v-text-field disabled label="Дата вручения" v-model="performDisplayValue" readonly v-on="on" />
        </template>
        <v-date-picker
            v-model="performDate"
            no-title
            scrollable
            locale="ru"
            first-day-of-week="1"
            :allowed-dates="allowedDates"
            disabled
        />
      </v-menu>

      <v-textarea v-model="note"
                  :auto-grow="true"
                  :clearable="true"
                  :filled="true"
                  placeholder="Дополнительная информация"
      />

    </v-card-text>
    <v-card-actions>
      <v-btn color="default" text @click="onCloseClicked" :disabled="loading">Закрыть</v-btn>
      <v-spacer/>
      <v-btn color="success" dark @click="onPerformClicked" :disabled="loading">Сохранить</v-btn>
    </v-card-actions>


    <v-snackbar v-if="isPerformFailed"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось сохранить
    </v-snackbar>

    <v-snackbar v-if="!isPerformFailed"
                :timeout="5000"
                :top="true"
                color="success"
    >
      Успешно
    </v-snackbar>
  </v-card>
</template>

<script>
import MailService from '../../../services/mail.service'
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import {Delivered} from "@/enums/perform.type";
import {APP_MAIL_PERFORMED} from "@/store/modules/app/actions";
import PostIndexService from "@/services/post.index.service";

export default {
  name: "SuccessDeliveredPerformMails",
  props: {
    mails: {
      type: Array,
      default: null
    },
    pfilters: {
      type: Object,
      region: null,
      area: null,
      start: null,
      end: null,
    }
  },
  data() {
    const today = new Date();
    const formattedDate = `${today.getDate()}.${today.getMonth() + 1}.${today.getFullYear()}`;
    return {
      note: null,
      performDate: today,
      performDisplayValue: formattedDate,
      performDateMenu: false,
      postCode: null,
      isPerformFailed: false,

      loading: false,
    }
  },
  computed: {
    allowedDates() {
      const today = new Date();
      return date => {
        const currentDate = new Date(date);
        return currentDate.toDateString() === today.toDateString();
      };
    },
  },
  methods: {
    onCloseClicked() {
      console.log("close")
      this.$emit('close-modal')
    },
    onPerformClicked() {
      const performType = Delivered;

      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START);

      MailService.performMails({
        performType: performType,
        client: this.$store.getters.appActiveClient,
        note: this.note,
        mails: this.mails.map(mail => mail.id),
        postCode: this.postCode,
      })
          .then(() => {
            for (let mail of this.mails) {
              PostIndexService.updatePostIndex({ id: mail.id, postIndex: this.postCode })
              this.$store.dispatch(APP_MAIL_PERFORMED, { mail: mail, performType: performType });
            }
            this.onCloseClicked();
          })
          .catch(() => {
            this.isPerformFailed = true;
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP);
          });
    }
  }
}
</script>

<style scoped>

</style>
